var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "materialOrder" },
    [
      _c(
        "van-tabs",
        {
          attrs: {
            animated: "",
            sticky: "",
            "title-active-color": "#F6D0AB",
            "title-inactive-color": "#39394D",
            type: "card"
          },
          model: {
            value: _vm.active,
            callback: function($$v) {
              _vm.active = $$v
            },
            expression: "active"
          }
        },
        [
          _c(
            "van-tab",
            { attrs: { title: "提料管理" } },
            [_c("keep-alive", [_c("keepMaterialAdmin")], 1)],
            1
          ),
          _c(
            "van-tab",
            { attrs: { title: "提料结算" } },
            [_c("keep-alive", [_c("keepMaterialJiesuan")], 1)],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabsLeftIcon", on: { click: _vm.ToPerson } },
        [_c("van-icon", { attrs: { name: "arrow-left", color: "#F6D0AB" } })],
        1
      ),
      (_vm.active == "0"
      ? true
      : false)
        ? _c("div", { staticClass: "top" }, [
            _c("div", { staticClass: "startTime" }, [_vm._v("开始时间")]),
            _c("div", { staticClass: "weight" }, [_vm._v("重量(g)")]),
            _c("div", { staticClass: "realTlmeMOney" }, [
              _vm._v("实时应收(元)")
            ]),
            _c("div", { staticClass: "state" }, [_vm._v("状态")])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }